/**
 * opora-report-enhance.js
 * State of Cleaning 2026 — sticky ToC, headline KPI cards, tool CTAs,
 * compare-table alignment, light regulatory timeline polish.
 * Draft-theme safe; no CMS writes.
 */
(function () {
  var ROOT_SEL = '.opora-page__content--state-report';
  var TOOL_HREF =
    /\/pages\/(bid-generator|bid-drafter|account-profitability-auditor|pfas|bid-stress-test|production-rate|bill-rate|rfp-decoder|scope-of-work|tools)/i;
  var TOOL_LABELS = {
    'bid-generator': 'Run Bid Generator',
    'bid-drafter': 'Open Bid Drafter',
    'account-profitability-auditor': 'Open Account Auditor',
    pfas: 'Open PFAS State Lookup',
    'bid-stress-test': 'Run Bid Stress Test',
    'production-rate': 'Open Production Rate Calculator',
    'bill-rate': 'Open Bill Rate Calculator',
    'rfp-decoder': 'Open RFP Decoder',
    'scope-of-work': 'Open Scope Generator',
    tools: 'Browse All Tools',
  };

  function extractStat(strongText) {
    var t = String(strongText || '').replace(/^\d+\.\s*/, '');
    var moneyRange = t.match(
      /\$[\d,]+(?:\.\d+)?\s*(?:billion|million)?\s+to\s+\$[\d,]+(?:\.\d+)?/i,
    );
    if (moneyRange) {
      return moneyRange[0]
        .replace(/\s+to\s+/i, '–')
        .replace(/\s*billion/gi, 'B')
        .replace(/\s*million/gi, 'M');
    }
    var money = t.match(/\$[\d,]+(?:\.\d+)?\s*(?:billion|million)?/i);
    if (money) {
      return money[0]
        .replace(/\s*billion/gi, 'B')
        .replace(/\s*million/gi, 'M')
        .replace(/\s+/g, ' ');
    }
    var big = t.match(/\b[\d,]{3,}\b/);
    if (big) return big[0];
    var pct = t.match(/\b[\d,]+\.?\d*%/);
    if (pct) return pct[0];
    var small = t.match(/\b\d+(?:\.\d+)?\b/);
    return small ? small[0] : '—';
  }

  function shorten(text, max) {
    max = max || 96;
    var t = String(text || '')
      .replace(/^\d+\.\s*/, '')
      .trim();
    if (t.length <= max) return t;
    var cut = t.slice(0, max);
    var sp = cut.lastIndexOf(' ');
    return (sp > 40 ? cut.slice(0, sp) : cut).trim() + '…';
  }

  function wrapTables(root) {
    root.querySelectorAll('table').forEach(function (table) {
      if (table.closest('.opora-table-scroll')) return;

      var caption = table.querySelector('caption');
      var captionEl = null;
      if (caption) {
        captionEl = document.createElement('p');
        captionEl.className = 'opora-table-caption';
        captionEl.innerHTML = caption.innerHTML;
        caption.remove();
      }

      var wrap = document.createElement('div');
      wrap.className = 'opora-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      if (captionEl) wrap.parentNode.insertBefore(captionEl, wrap);
      wrap.appendChild(table);

      table.querySelectorAll('tbody tr').forEach(function (tr) {
        var label = (tr.cells[0] && tr.cells[0].textContent) || '';
        if (/total|subtotal/i.test(label)) tr.classList.add('opora-table-row--total');
      });

      // Feature / vendor matrices stay left-aligned (not numeric right-align)
      var head = ((table.tHead && table.tHead.textContent) || '').toLowerCase();
      var first = ((table.rows[0] && table.rows[0].textContent) || '').toLowerCase();
      if (
        /swept|janitorial manager|cleantelligent/.test(head + first) ||
        (/feature/.test(head) && table.rows[0] && table.rows[0].cells.length >= 3)
      ) {
        table.classList.add('opora-compare-table');
      }
    });
  }

  function enhanceHeadlineKpis(root) {
    if (root.querySelector('.opora-kpi-grid')) return;
    var h3s = root.querySelectorAll('h3');
    var findingsH = null;
    h3s.forEach(function (h) {
      if (/headline findings/i.test(h.textContent || '')) findingsH = h;
    });
    if (!findingsH) return;

    var cards = [];
    var node = findingsH.nextElementSibling;
    while (node && node.tagName !== 'H3' && node.tagName !== 'H2') {
      if (node.tagName === 'P') {
        var strong = node.querySelector('strong');
        if (strong) {
          cards.push({
            stat: extractStat(strong.textContent),
            cap: shorten(strong.textContent),
            el: node,
          });
        }
      }
      node = node.nextElementSibling;
    }
    if (cards.length < 4) return;

    var grid = document.createElement('div');
    grid.className = 'opora-kpi-grid';
    grid.setAttribute('aria-label', 'Headline findings');
    cards.slice(0, 8).forEach(function (c) {
      var card = document.createElement('div');
      card.className = 'opora-kpi-card';
      card.innerHTML =
        '<div class="opora-kpi-stat"></div><div class="opora-kpi-cap"></div>';
      card.querySelector('.opora-kpi-stat').textContent = c.stat;
      card.querySelector('.opora-kpi-cap').textContent = c.cap;
      grid.appendChild(card);
    });
    findingsH.parentNode.insertBefore(grid, findingsH.nextSibling);

    // Collapse the long prose list under a details for scannability
    var details = document.createElement('details');
    details.className = 'opora-kpi-detail';
    var summary = document.createElement('summary');
    summary.textContent = 'Read the full finding notes';
    details.appendChild(summary);
    cards.forEach(function (c) {
      details.appendChild(c.el);
    });
    grid.parentNode.insertBefore(details, grid.nextSibling);
  }

  function enhanceToolCtas(root) {
    root.querySelectorAll('a[href]').forEach(function (a) {
      if (a.closest('.opora-tool-cta, .report-tldr, .orep-outro, .orep-part-cta')) return;
      var href = a.getAttribute('href') || '';
      var m = href.match(TOOL_HREF);
      if (!m) return;
      // Only promote when the link is a standalone sentence ender or short CTA-ish anchor
      var text = (a.textContent || '').trim();
      if (text.length > 80) return;
      var parent = a.parentElement;
      if (!parent || parent.tagName !== 'P') return;
      // Skip if paragraph is mostly prose with many other links
      if (parent.querySelectorAll('a').length > 2) return;

      var key = m[1].toLowerCase();
      var label = TOOL_LABELS[key] || ('Open ' + text);
      var box = document.createElement('aside');
      box.className = 'opora-tool-cta';
      box.innerHTML =
        '<p class="opora-tool-cta__eyebrow">Put the numbers to work</p>' +
        '<p class="opora-tool-cta__text"></p>' +
        '<a class="opora-tool-cta__btn" href=""></a>';
      box.querySelector('.opora-tool-cta__text').textContent =
        'This section maps directly to an Opora tool.';
      var btn = box.querySelector('.opora-tool-cta__btn');
      btn.href = href;
      btn.textContent = label + ' →';
      parent.parentNode.insertBefore(box, parent.nextSibling);
    });
  }

  function enhanceRegulatoryTimeline(root) {
    // Style PFAS / HazCom tables when present
    root.querySelectorAll('table').forEach(function (table) {
      var cap = (
        (table.previousElementSibling &&
          table.previousElementSibling.classList.contains('opora-table-caption') &&
          table.previousElementSibling.textContent) ||
        ''
      ).toLowerCase();
      var head = ((table.tHead && table.tHead.textContent) || '').toLowerCase();
      if (/pfas|effective date|hazcom|regulatory/.test(cap + head)) {
        table.classList.add('opora-timeline-table');
        var wrap = table.closest('.opora-table-scroll');
        if (wrap) wrap.classList.add('opora-timeline-wrap');
      }
    });
  }

  function buildStickyToc(root) {
    if (document.querySelector('.opora-report-layout')) return;

    var headings = [];
    root.querySelectorAll('h2[id], section[id] > h2, h2').forEach(function (h2) {
      var id = h2.id;
      if (!id) {
        var sec = h2.closest('section[id]');
        id = sec && sec.id;
      }
      if (!id) return;
      var text = (h2.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || /frequently asked/i.test(text)) return;
      headings.push({ id: id, text: text });
    });
    if (headings.length < 3) return;

    var layout = document.createElement('div');
    layout.className = 'opora-report-layout';
    var aside = document.createElement('aside');
    aside.className = 'opora-report-toc';
    aside.setAttribute('aria-label', 'Report sections');
    aside.innerHTML =
      '<p class="opora-report-toc__label">On this page</p><nav class="opora-report-toc__nav"></nav>';
    var nav = aside.querySelector('.opora-report-toc__nav');
    headings.forEach(function (h) {
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'opora-report-toc__link';
      a.dataset.section = h.id;
      a.textContent = h.text;
      nav.appendChild(a);
    });

    var main = document.createElement('div');
    main.className = 'opora-report-main';
    var parent = root.parentNode;
    parent.insertBefore(layout, root);
    layout.appendChild(aside);
    layout.appendChild(main);
    main.appendChild(root);

    // Scroll spy
    var links = aside.querySelectorAll('.opora-report-toc__link');
    function setActive(id) {
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.dataset.section === id);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) setActive(en.target.id);
          });
        },
        { rootMargin: '-20% 0px -65% 0px', threshold: 0 },
      );
      headings.forEach(function (h) {
        var el = document.getElementById(h.id);
        if (el) io.observe(el);
      });
    }
  }

  function polishHero(root) {
    var meta = root.querySelector('.report-meta');
    if (!meta || root.querySelector('.opora-report-hero')) return;
    var title = root.querySelector('.report-title, h1');
    var sub = root.querySelector('.report-sub');

    // Part 1 CMS body has meta/sub but no report-title — synthesize from theme page H1 or default
    if (!title) {
      var pageH1 = document.querySelector('.page__title, .page__header h1');
      title = document.createElement('h1');
      title.className = 'report-title';
      title.textContent =
        (pageH1 && pageH1.textContent.trim()) ||
        'State of Commercial Cleaning Operations 2026';
      if (pageH1) {
        var header = pageH1.closest('.page__header');
        if (header) header.style.display = 'none';
      }
    }

    var hero = document.createElement('div');
    hero.className = 'opora-report-hero';
    var bits = [meta, title];
    if (sub) bits.push(sub);
    var byline = root.querySelector('.report-byline');
    if (byline) bits.push(byline);
    var divider = root.querySelector('.report-divider');
    bits.forEach(function (el) {
      hero.appendChild(el);
    });
    if (divider) divider.remove();

    var actions = document.createElement('div');
    actions.className = 'opora-report-hero__actions';
    var pdf =
      document.querySelector('.orep-part-cta__btn--secondary') ||
      document.querySelector('[data-report-pdf]');
    var readMin = Math.max(12, Math.round((root.textContent || '').split(/\s+/).length / 220));
    actions.innerHTML =
      '<span class="opora-report-hero__read">' +
      readMin +
      ' min read</span>';
    if (pdf && pdf.href) {
      var a = document.createElement('a');
      a.className = 'opora-report-hero__pdf';
      a.href = pdf.href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Download Full PDF';
      actions.appendChild(a);
    }
    hero.appendChild(actions);
    root.insertBefore(hero, root.firstChild);
  }

  function run() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    wrapTables(root);
    polishHero(root);
    enhanceHeadlineKpis(root);
    enhanceToolCtas(root);
    enhanceRegulatoryTimeline(root);
    buildStickyToc(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
